<template>
  <div class="i-panel-item ui-layout-west">
    <div style="height: calc(100vh - 152px)" class="overflow-y-auto">
      <slot />
    </div>
    <div class="footer placeholder-footer">
      <slot name="footer" />
    </div>
  </div>
</template>
